import styled from 'styled-components';

import { NewStyleColor } from '../../../utils/styles-constants';

const StyledButtonAddPage = styled('button')`
	display: flex;
	align-items: center;
	width: 25px;
	height: 23px;
	padding: 4px 5px;
	border: 1px solid ${NewStyleColor.White}
	border-radius: 5px;
	outline: 0;
	background-color: ${NewStyleColor.Grey900};
	color: ${NewStyleColor.White};
	cursor: pointer;

	svg {
		width: 13px;
		height: 13px;
		fill: currentColor;
	}
`;

export {
	StyledButtonAddPage,
};


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/ButtonAddPage/styles.ts